import gql from 'graphql-tag';

const ONBOARD_MERCHANT_VENUES = gql`
  mutation addPlacesToMerchantVenues(
    $merchantUuid: String!
    $placeDescriptions: [PlaceDescription!]!
  ) {
    addPlacesToMerchantVenues(
      merchantUuid: $merchantUuid
      placeDescriptions: $placeDescriptions
    ) {
      successful
    }
  }
`;

export { ONBOARD_MERCHANT_VENUES };
